import _ from 'lodash';
import tolLocations from '../data/location/tolLocations.json';
import ddPropertyLocations from '../data/location/ddpropertyLocations.json';

type LocationProps = {
  type_code: string;
  code: string;
  thai_name: string;
  english_name?: string;
};

export function getDDLocationCode(
  location: string,
  locationGroup: string[],
): {
  code?: string;
  type?: 'province' | 'district' | 'area';
} {
  const normalizeString = (str: string) =>
    str?.toLowerCase().replace(/\s+/g, '');

  const normalizedLocation = normalizeString(location);

  const combinedLocations = [
    ...tolLocations,
    ...ddPropertyLocations,
  ] as LocationProps[];

  const matchedLocation = _.find(combinedLocations, (location) => {
    const normalizedEnglishName = normalizeString(location.english_name || '');
    const normalizedThaiName = normalizeString(location.thai_name);

    return (
      normalizedLocation === normalizedEnglishName ||
      (normalizedLocation === normalizedThaiName &&
        locationGroup.includes(location.type_code))
    );
  });

  return {
    code: matchedLocation?.code,
    type: locationTypeMap[matchedLocation?.type_code],
  };
}
const locationTypeMap: Record<string, 'district' | 'province' | 'area'> = {
  'D': 'district',
  'L': 'province',
  'A': 'area',
};
